import { TreeNodeType } from "components/Tree/types";
import { highlightText } from "components/helpers";

import { RecordLabel } from "../../RecordLabel";
import { useLeftSidebarContext } from "../../context";

import styles from "./styles.module.scss";

type Props = {
  node: TreeNodeType;
};

export const DefaultLabel = (props: Props) => {
  const { node } = props;
  const { label } = node;
  const { databaseSearchState } = useLeftSidebarContext();
  return (
    <RecordLabel className={styles.generalLabel}>
      {highlightText({
        searchWord: databaseSearchState,
        textToHighlight: label,
      })}
    </RecordLabel>
  );
};
